import React from 'react'
import Label from '../atoms/Label'
import './RangeSlider.css'

const RangeSlider = ({ 
  label, 
  value, 
  onChange, 
  min = 0, 
  max = 100, 
  step = 1, 
  unit = '', 
  showValue = true, 
  id = '',
  className = '',
  ...props 
}) => {
  const classes = [
    'range-slider',
    className
  ].filter(Boolean).join(' ')

  const percentage = ((value - min) / (max - min)) * 100

  return (
    <div className={classes} {...props}>
      {label && (
        <div className="range-slider-header">
          <Label htmlFor={id}>{label}</Label>
          {showValue && (
            <span className="range-slider-value">
              {value}{unit}
            </span>
          )}
        </div>
      )}
      <div className="range-slider-wrapper">
        <input
          type="range"
          id={id}
          className="range-slider-input"
          value={value}
          onChange={onChange}
          min={min}
          max={max}
          step={step}
        />
        <div 
          className="range-slider-track"
          style={{ 
            background: `linear-gradient(to right, var(--accent) 0%, var(--accent) ${percentage}%, var(--border) ${percentage}%, var(--border) 100%)`
          }}
        />
      </div>
    </div>
  )
}

export default RangeSlider
